export const newsSegments = {
  newsId: ':id',
};

export const newsPaths = {
  getMkNews: '/mk-api',
  getCoindeskNews: '/coindesk-api',
  getCointelegraph: '/cointelegraph-api',
  pressList: '/api/news/press-list',
  newsList: '/api/news',
  newsSearch: '/api/news-search',
} as const;
